import { Component, Input, OnInit } from '@angular/core';
import { AlertMessageModel } from '../../models/alert-message.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss'],
  standalone: false,
})
export class AlertMessageComponent implements OnInit {
  @Input()
  public alertMessage?: AlertMessageModel;

  constructor(public readonly translateService: TranslateService) {
  }

  ngOnInit(): void {
  }
}
